import { LOAD_FEATURE_USER_SETTINGS } from 'actions/actionTypes';
import { getFeatureUserSettings } from 'api/featureUserSettings';
import {
  getFeatureUserSettingsSuccess,
  getFeatureUserSettingsFailure,
  updateFeatureUserSettings,
} from 'actions';
import { COHORT_MEMBER_TYPE } from 'constants/launchDarklyConstants';
import { toInteger, get } from 'lodash';
import { apiPromise } from './apiPromise';

const transformFeatureUserSettings = settings => {
  // convert LaunchDarkly user key to integer - keeping it consistent with the backend behavior
  const key = toInteger(get(settings, 'key', 0));
  const customerId = toInteger(get(settings, 'custom.customerId', 0));

  const { custom: customFields, ...userFields } = settings;

  // TODO: Make cohortMember* fields dynamic/update them for each feature flag
  return {
    ...userFields,
    key,
    custom: {
      ...customFields,
      customerId,
      cohortMemberType: COHORT_MEMBER_TYPE,
      cohortMembershipKey: customerId
    }
  };
};

export const featureUserSettings = store => next => (action) => {
  switch (action.type) {
    case LOAD_FEATURE_USER_SETTINGS.REQUEST:
    {
      next(action);
      return apiPromise(
        store,
        action,
        getFeatureUserSettings,
        [],
        getFeatureUserSettingsSuccess,
        getFeatureUserSettingsFailure
      );
    }
    case LOAD_FEATURE_USER_SETTINGS.SUCCESS: {
      // make a segment identify call
      const { dispatch } = store;
      const { launchDarklySettings: settings } = get(action, 'payload', undefined);

      if (settings) {
        const transformedSettings = transformFeatureUserSettings(settings);
        dispatch(updateFeatureUserSettings(transformedSettings));
      }

      next(action);
      return Promise.resolve();
    }
    default:
      next(action);
      return Promise.resolve();
  }
};

export default featureUserSettings;
